import { Routes, Route, Navigate } from 'react-router-dom';
import InventoryCountsList from './inventory-counts/InventoryCountsList';
import InventoryCountDetail from './inventory-counts/InventoryCountDetail';
import InventoryCountActive from './inventory-counts/InventoryCountActive';

export default function InventoryCounts() {
  return (
    <Routes>
      <Route index element={<InventoryCountsList />} />
      <Route path=":id" element={<InventoryCountDetail />} />
      <Route path=":id/count" element={<InventoryCountActive />} />
      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
  );
}
